import styled from '@emotion/styled';
import { Model } from '@gameonly/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Markdown from '../ui/Markdown';
import { GraphTitle } from './ResultGraph';
import { getHumanizedValue } from './SeedsTooltipComponent';

// duplicate of a similar function server side : both are to be updated !
const parseValueAndUnit = (
  input: string | undefined,
): { value: number; unit: string } | null => {
  if (!input) {
    return null;
  }

  const match = input.match(/^([\d\.]+)\s*(\S+)$/);

  if (!match) {
    console.log(
      `Invalid input format. Expected format: '<number> <unit>'. Input is ${input}`,
    );
    return null;
  }

  const value = parseFloat(match[1]);
  const unit = match[2];

  return { value, unit };
};

const GlobalScoreContainer = styled.div`
  width: 100%;
  background-color: white;
  position: relative;
  margin: 16px 0;
  padding: 0 16px;
`;
const ScoreComponent = styled.div`
  margin-top: 16px;
  width: 100%;
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px;
  > p {
    flex: 1;
  }
  > p:first-of-type {
    text-align: center;
    background: var(--bg-score);
    padding: 6px 0;
    border-radius: 24px;
  }
`;

interface GlobalScoreComponentProps {
  title?: string;
  subtitle?: string;
  score?: string;
  children: React.ReactNode;
  dashboard?: boolean;
  code?: string;
  model?: Model;
  uncertainty?: number;
}

const GlobalScoreComponent = ({
  title,
  score,
  subtitle,
  uncertainty,
  children,
  dashboard,
  code,
  model,
}: GlobalScoreComponentProps) => {
  const { t, i18n } = useTranslation(['project', 'model']);
  const translationPrefix = `model:${model?.name.toLowerCase()}.result.${code?.toLowerCase()}`;

  const parsedScore = parseValueAndUnit(score);
  let displayedScore: string = score || '';
  if (parsedScore) {
    displayedScore = getHumanizedValue(parsedScore.value) + ' ' + parsedScore.unit
  }

  if (dashboard) {
    return (
      <div>
        <p className="h5r">{t(`${translationPrefix}.title`)}</p>
        <p className="h3b">{displayedScore}</p>
      </div>
    );
  }
  return (
    <GlobalScoreContainer>
      {i18n.exists(`${translationPrefix}.title`) && (
        <GraphTitle
          text={t(`${translationPrefix}.title`)}
          size="full"
          color="default"
        />
      )}
      <ScoreComponent>
        <p className="h3b">
          {getHumanizedValue(displayedScore)} {uncertainty && <> ± {(uncertainty * 100).toFixed(0)}%</>}
        </p>
        {children}
      </ScoreComponent>

      {i18n.exists(`${translationPrefix}.subtitle`) && (
        <Markdown>{t(`${translationPrefix}.subtitle`)}</Markdown>
      )}
    </GlobalScoreContainer>
  );
};

export default GlobalScoreComponent;
